<template>
  <div
    v-if="visible"
    class="modal-overlay"
    @click.self="$emit('close')"
    style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5); z-index: 1050; display: flex; align-items: center; justify-content: center;">
    <div
      role="dialog"
      class="users-limit-modal"
      style="pointer-events: auto; max-width: 30rem; width: 92%; background: white; border-radius: 0.75rem; padding: 0; position: relative; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);">
      <div style="display: flex; align-items: center; justify-content: space-between; padding: 1.5rem 1.5rem 0.75rem 1.5rem;">
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4f46e5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
          <h3 style="font-size: 1.125rem; font-weight: 700; margin: 0; color: #111827;">Limite de usuários atingido</h3>
        </div>
        <button
          type="button"
          style="background: transparent; border: none; cursor: pointer; padding: 0.25rem; color: #6b7280;"
          @click="$emit('close')">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
        </button>
      </div>
      <div style="padding: 0.25rem 1.5rem 1.5rem 1.5rem;">
        <p style="margin: 0; font-size: 1rem; line-height: 1.5; color: #64748b;">
          {{ displayMessage }}
        </p>
        <div style="display: flex; justify-content: flex-end; margin-top: 1.25rem;">
          <button
            type="button"
            class="users-limit-upgrade-button"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; border-radius: 0.625rem; font-size: 0.9rem; font-weight: 500; height: 2.625rem; padding-left: 1.5rem; padding-right: 1.5rem; border: none; cursor: pointer;"
            @click="$emit('upgrade-click')">
            Ver opções de upgrade
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserLimitReachedModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    maxActiveUsers: {
      type: Number,
      default: 0
    },
    message: {
      type: String,
      default: ''
    }
  },
  computed: {
    displayMessage () {
      if (typeof this.message === 'string' && this.message.trim() !== '') return this.message
      if (this.maxActiveUsers > 0) {
        return `No modelo de recarga você tem limite de até ${this.maxActiveUsers} usuários ativos. Quer expandir seu time? Conheça nossos planos com usuários ilimitados.`
      }
      return 'Sua conta no modelo Recarga atingiu o limite de usuários ativos. Para adicionar mais usuários, migre para um plano.'
    }
  }
}
</script>

<style scoped>
.users-limit-upgrade-button {
  color: #ffffff;
  background: linear-gradient(90deg, #2563eb 0%, #1d4ed8 55%, #1e40af 100%);
  transition: opacity 0.2s ease;
}

.users-limit-upgrade-button:hover {
  opacity: 0.92;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/UserLimitReachedModal.vue